import { render, staticRenderFns } from "./leaderboard.vue?vue&type=template&id=6259c7ac&"
import script from "./leaderboard.vue?vue&type=script&lang=ts&"
export * from "./leaderboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports